export default __webpack_public_path__ + "static/media/company-default.9d86bcda.svg";